export default function KcLoading() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-linear-to-br from-gray-100 to-blue-100">
      <div className="bg-white p-10 rounded-2xl shadow-2xl flex flex-col items-center max-w-sm w-full">
        <svg
          className="animate-spin mb-4"
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
        >
          <circle
            cx="32"
            cy="32"
            r="28"
            stroke="#0143D1"
            strokeWidth="8"
            opacity="0.2"
          />
          <path
            d="M60 32a28 28 0 0 1-28 28"
            stroke="#0143D1"
            strokeWidth="8"
            strokeLinecap="round"
          />
        </svg>
        <h1 className="text-gray-900 text-2xl mt-2 mb-2 font-bold text-center">
          Carregando...
        </h1>
        <p className="text-gray-600 text-base text-center">
          Aguarde enquanto autenticamos sua sessão.
        </p>
      </div>
    </div>
  );
}
